import { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Cake } from "lucide-react";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const next = location.state?.next || "/order";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setErr("");
    try {
      const u = await login(email, password);
      toast.success(u.role === "admin" ? "Welcome back, Sarah!" : "Welcome back!");
      navigate(u.role === "admin" ? "/admin" : next);
    } catch (e2) {
      setErr(apiError(e2.response?.data?.detail) || e2.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="App">
      <Navbar />
      <div className="mx-auto flex max-w-md flex-col px-6 py-16">
        <div className="mb-8 text-center">
          <span className="mx-auto grid h-14 w-14 place-items-center rounded-2xl bg-sugar-pink text-white"><Cake size={26} /></span>
          <h1 className="mt-4 font-display text-3xl font-extrabold text-sugar-ink">Welcome back</h1>
          <p className="mt-1 text-sm text-sugar-ink2">Log in to order and track your cakes</p>
        </div>
        <form onSubmit={submit} className="space-y-4 rounded-2xl border border-sugar-border bg-white p-7 sugar-card-shadow">
          {err && <p data-testid="login-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm font-medium text-red-600">{err}</p>}
          <div>
            <label className="mb-1.5 block text-sm font-bold text-sugar-ink">Email</label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="rounded-xl border-sugar-border" />
          </div>
          <div>
            <label className="mb-1.5 block text-sm font-bold text-sugar-ink">Password</label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="rounded-xl border-sugar-border" />
          </div>
          <Button data-testid="login-submit" disabled={loading} type="submit" className="w-full rounded-full bg-sugar-pink py-6 font-bold text-white hover:bg-sugar-pinkhover">
            {loading ? "Logging in..." : "Log in"}
          </Button>
          <p className="text-center text-sm">
            <Link data-testid="login-forgot-password" to="/forgot-password" className="font-bold text-sugar-pink">Forgot password?</Link>
          </p>
          <p className="text-center text-sm text-sugar-ink2">
            New here? <Link data-testid="login-to-register" to="/register" state={{ next }} className="font-bold text-sugar-pink">Create an account</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
